
import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";


const CursoTipoMonedaForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos,tipomonedaCombo, cursoCombo})=>{



	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["CursoTipoMoneda"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
        
                            <Form.Field  required  error={errors.idCurso}>
                              <label  >{strings?strings["idCurso"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idCurso"]:""} 
                                    name="idCurso"
                                     fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.idCurso}
                                    options={cursoCombo}/>
                            </Form.Field>
                                            
                        
                            <Form.Field  required  error={errors.idTipoMoneda}>
                              <label  >{strings?strings["idTipoMoneda"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idTipoMoneda"]:""} 
                                    name="idTipoMoneda"
                                     fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.idTipoMoneda}
                                    options={tipomonedaCombo}/>
                            </Form.Field>
        
        
            
                                            
                            <Form.Field  required  error={errors.monto}>            
                              <label  >{strings?strings["monto"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["monto"]:""} 
                                    name="monto"
                                    onChange={onChange}
                                    value={datos.monto}
                                    icon='edit'/>
                            </Form.Field>
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/cursotipomonedas">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default CursoTipoMonedaForm;